import { render } from "./BoardYearContent.vue?vue&type=template&id=f24d8388"
import script from "./BoardYearContent.vue?vue&type=script&lang=js"
export * from "./BoardYearContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__